import categoryDefinitions from '@/services/keymapService/categoryDefinitions'
import initiativeKeymaps from '@/services/keymapService/initiativeKeyMaps'
import * as R from 'ramda'
import isMac from '@/utils/isMac'

export const KEYMAP_DATA = {
  CATEGORIES: [],
  ACTIVE_CATEGORIES: [],
  ACTIVE_CONFIG: null,
  ACTIVE_KEYMAP: null,
  EVENTS: []
}

export function addEvent(eventName) {
  KEYMAP_DATA.EVENTS.push(eventName)
}

export function removeEvent(eventName) {
  // remove first occurrence
  const eventIndex = KEYMAP_DATA.EVENTS.findIndex(name => name === eventName)
  if (eventIndex > -1) KEYMAP_DATA.EVENTS = R.remove(eventIndex, 1, KEYMAP_DATA.EVENTS)
}

export function removeEventsOfType(eventName) {
  KEYMAP_DATA.EVENTS = KEYMAP_DATA.EVENTS.filter(item => item.startsWith(eventName))
}

window.KEYMAP_DATA = KEYMAP_DATA
let defcategory = function(name, handlers) {
  const categoryDefinition = categoryDefinitions[name]
  const actions = categoryDefinition.actions.filter(action => handlers[action.name])
  KEYMAP_DATA.CATEGORIES[name] = {
    name: name,
    description: categoryDefinition.description,
    actions: actions
  }
}

function makeKeymap(categories, config) {
  let keys = {}
  categories.forEach(x => {
    Object.entries(config[x.name]).map(([key, action]) => {
      if (keys[key]) {
        keys[key].push(action)
      } else {
        keys[key] = [action]
      }
    })
  })
  return keys
}

export function activateCategory(name, handlers) {
  console.log('activating category', name)
  defcategory(name, handlers)
  const category = KEYMAP_DATA.CATEGORIES[name]
  const meta = category.actions.reduce(
    (acc, action) => ({
      ...acc,
      [action.name]: { description: action.description, shouldList: action.shouldList }
    }),
    {}
  )
  KEYMAP_DATA.ACTIVE_CATEGORIES.push({ name, handlers, meta, description: category.description })
  KEYMAP_DATA.ACTIVE_KEYMAP = makeKeymap(KEYMAP_DATA.ACTIVE_CATEGORIES, KEYMAP_DATA.ACTIVE_CONFIG)
}

export function deactivateCategory(name) {
  console.log('deactivating category', name)
  KEYMAP_DATA.ACTIVE_CATEGORIES = KEYMAP_DATA.ACTIVE_CATEGORIES.filter(x => x.name !== name)
  KEYMAP_DATA.ACTIVE_KEYMAP = makeKeymap(KEYMAP_DATA.ACTIVE_CATEGORIES, KEYMAP_DATA.ACTIVE_CONFIG)
}

function isDisAllowedInputField(elementType, key) {
  if (['text', 'number', 'email'].some(R.equals(elementType))) {
    return true
  } else if (elementType === 'search') {
    return R.none(R.equals(key), ['<up>', '<down>'])
  }
}

function ignorableElement(element, key) {
  return (
    key !== '<escape>' &&
    key != 'Ctrl-<return>' &&
    ((element.tagName === 'INPUT' && isDisAllowedInputField(element.type, key)) ||
      element.tagName === 'TEXTAREA' ||
      element.tagName === 'SELECT')
  )
}

function ignorableEvent(event) {
  let key = event.key || event.which
  const ignoredKeys = ['Control', 'Alt', 'Shift', 'Meta']
  return ignoredKeys.indexOf(key) !== -1
}

function normalizeShiftModifiedKey(key) {
  return key.replace(/^Shift-([A-Z?])$/, '$1')
}

function normalizedKey(event) {
  let name = ''
  // for control (in mac) prefix is Control-
  // for control (in windows/linux) and command (in mac),  prefix is Ctrl-
  // prefix Meta- is for windows key
  if (event.ctrlKey) {
    if (isMac) {
      name += 'Control-'
    } else {
      name += 'Ctrl-'
    }
  }
  if (event.shiftKey) name += 'Shift-'
  if (event.altKey) name += 'Alt-'
  if (event.metaKey) {
    if (isMac) {
      name += 'Ctrl-'
    } else {
      name += 'Meta-'
    }
  }
  let otherKey = event.key || event.which
  let otherKeyMap = {
    Escape: '<escape>',
    Enter: '<return>',
    ArrowUp: '<up>',
    ArrowDown: '<down>',
    ArrowLeft: '<left>',
    ArrowRight: '<right>',
    Backspace: isMac ? '<delete>' : '<backspace>',
    Delete: '<delete>',
    Tab: '<tab>',
    ' ': '<space>'
  }
  name += otherKeyMap[otherKey] || otherKey
  return normalizeShiftModifiedKey(name)
}

function executeHandlers(handlers, event) {
  handlers.forEach(x => {
    if (typeof x.handler === 'object') {
      x.handler.callback(event)
    } else {
      x.handler(event)
    }
  })
}

function performAction(actionName, event) {
  let handlers = []
  KEYMAP_DATA.ACTIVE_CATEGORIES.forEach(category => {
    actionName.forEach(action => {
      category.handlers[action] &&
        handlers.push({
          handler: category.handlers[action],
          category: category.name
        })
    })
  })
  const [alwaysExecutables, remainingExecutables] = R.partition(
    R.path(['handler', 'alwaysExecute']),
    handlers
  )
  const preventKBHandlers =
    R.intersection(['POPOVER_SHOWN', 'MODAL_SHOWN'], KEYMAP_DATA.EVENTS).length > 0
  executeHandlers(alwaysExecutables, event)
  if (!preventKBHandlers) executeHandlers(remainingExecutables, event)
}

export function enable() {
  document.addEventListener('keydown', function(event) {
    let keymap = KEYMAP_DATA.ACTIVE_KEYMAP
    let active = document.activeElement
    let key = normalizedKey(event)
    if (
      !keymap ||
      ignorableEvent(event) ||
      (active && active.offsetParent && ignorableElement(active, key))
    ) {
      return
    }
    let action = keymap[key]
    if (action) {
      console.log('performing keydown action', action)
      performAction(action, event)
    }
  })
}

export const selectItem = el => {
  el.classList.add('selected')
}

export function selectListItem(container, direction) {
  if (!(direction === 'next' || direction === 'previous')) {
    console.warn('Unknown task direction', direction)
    return
  }
  let items = Array.from(container.querySelectorAll('.select-list-item'))
  if (items.length === 0) {
    return
  }
  let lastIndex = items.length - 1
  let selected = items.find(item => item.classList.contains('selected'))
  let selectedIndex = selected ? items.indexOf(selected) : -1
  let newIndex = direction === 'next' ? selectedIndex + 1 : selectedIndex - 1
  if (newIndex >= 0 && newIndex <= lastIndex) {
    if (selected) {
      selected.classList.remove('selected')
    }
    selectItem(items[newIndex])
  }
}

export function selectedListItem(container) {
  return container.querySelector('.select-list-item.selected')
}

export function clearSelection() {
  const selectedItem = document.querySelectorAll('.select-list-item.selected')
  selectedItem.forEach(item => {
    item.classList.remove('selected')
  })
}

export let DEFAULT_CONFIG = {
  global: {
    '?': 'view-shortcuts',
    p: 'profile-menu',
    '<escape>': 'escape',
    n: 'quick-add-initiative',
    w: 'navigate-to-your-goals',
    o: 'navigate-to-org-goals',
    'Ctrl-<return>': 'submit-form',
    'Shift-<left>': 'navigate-to-previous-page',
    '/': 'open-search'
  },
  inbox: {
    i: 'open-inbox',
    '<escape>': 'close-inbox'
  },
  archives: {
    '<up>': 'previous-item',
    '<down>': 'next-item',
    '<right>': 'expand-item',
    '<left>': 'collapse-item',
    '<return>': 'toggle-expansion',
    'Shift-<right>': 'open',
    '<space>': 'checkin',
    e: 'edit-item',
    '<escape>': 'cancel-editing',
    a: 'add-initiative',
    c: 'comment'
  },
  goals: {
    '<up>': 'previous-item',
    '<down>': 'next-item',
    '<right>': 'expand-item',
    '<left>': 'collapse-item',
    '<return>': 'toggle-expansion',
    'Shift-<right>': 'open',
    '<space>': 'checkin',
    e: 'edit-item',
    '<escape>': 'cancel-editing',
    a: 'add-initiative',
    c: 'comment',
    'Ctrl-<delete>': 'delete-initiative',
    b: 'bulk-checkin'
  },
  'edit-goal': {
    a: 'add-kr'
  },
  yourWork: {
    '<escape>': 'cancel-editing',
    b: 'bulk-checkin'
  },
  goal: {
    '<up>': 'previous-item',
    '<down>': 'next-item',
    '<space>': 'checkin',
    '<return>': 'toggle-expansion',
    'Shift-<right>': 'open',
    e: 'edit-item',
    '<right>': 'expand-item',
    '<left>': 'collapse-item',
    '<escape>': 'cancel-editing',
    a: 'add-initiative',
    c: 'comment',
    'Ctrl-<delete>': 'delete-initiative'
  },
  kr: {
    '<up>': 'previous-item',
    '<down>': 'next-item',
    '<right>': 'expand-item',
    '<left>': 'collapse-item',
    '<return>': 'toggle-expansion',
    'Shift-<right>': 'open',
    '<space>': 'done-undone-item',
    '<escape>': 'cancel-editing',
    'Ctrl-<delete>': 'delete-initiative',
    e: 'edit-initiative',
    a: 'add-initiative',
    c: 'comment'
  },
  ideaList: {
    '<up>': 'previous-item',
    '<down>': 'next-item',
    '<right>': 'expand-item',
    '<left>': 'collapse-item',
    '<return>': 'toggle-expansion',
    'Shift-<right>': 'open',
    '<space>': 'done-undone-item',
    '<escape>': 'cancel-editing',
    e: 'edit-idea',
    a: 'add-idea',
    c: 'comment'
  },
  initiative: {
    a: 'add-task',
    'Ctrl-<delete>': 'delete-task',
    e: 'edit-initiative',
    '<escape>': 'cancel-editing',
    c: 'comment',
    '<up>': 'previous-item',
    '<down>': 'next-item',
    'Shift-<right>': 'open',
    '<space>': 'done-undone-item'
  },
  allInitiatives: initiativeKeymaps.keyMaps,
  initiativesListView: { ...initiativeKeymaps.keyMaps, a: 'add-initiative' },
  sidebar: {
    '[': 'toggle-sidebar'
  },
  spotlightSearch: {
    '<up>': 'previous-search-item',
    '<down>': 'next-search-item',
    '<return>': 'view-search-item'
  },
  initiativeModal: {
    '<right>': 'next-initiative',
    '<left>': 'previous-initiative'
  },
  ideaModal: {
    '<right>': 'next-idea',
    '<left>': 'previous-idea'
  },
  ideaLists: {
    '<up>': 'previous-item',
    '<down>': 'next-item',
    '<right>': 'expand-item',
    '<left>': 'collapse-item',
    '<return>': 'toggle-expansion',
    'Shift-<right>': 'open',
    '<space>': 'done-undone-item',
    e: 'edit-idea',
    '<escape>': 'cancel-editing',
    a: 'add-idea',
    c: 'comment'
  },
  myWork: {
    a: 'add-task',
    '?': 'view-shortcuts',
    'Shift-<right>': 'open',
    ...initiativeKeymaps.keyMaps
  }
}

KEYMAP_DATA.ACTIVE_CONFIG = DEFAULT_CONFIG
